
export function HowItWorksSection() {
  const steps = [
    {
      icon: 'ri-search-eye-line',
      title: 'Detect',
      subtitle: 'UK-Trained AI Scanning',
      description: 'Our UK-trained AI scans emails & SMS in real-time, analyzing patterns specific to regional attack methods and local threat intelligence.',
      features: ['Real-time message analysis', 'UK-specific threat patterns', 'Machine learning detection', 'Natural language processing']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Prevent & Educate',
      subtitle: 'Block & Train Instantly',
      description: 'We block threats immediately and send instant training nudges to your team, turning every interaction into a learning opportunity.',
      features: ['Instant threat blocking', 'Real-time education nudges', 'Micro-learning approach', 'No formal training needed']
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Empower',
      subtitle: 'Clear Insights Dashboard',
      description: 'Gain clear insights from your unified dashboard to strengthen your defenses and track your team\'s security improvement.',
      features: ['Employee risk scores', 'Threat attempt tracking', 'Actionable insights', 'Security trend analysis']
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center text-white">
            How It Works
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto text-center leading-relaxed mb-16">
            Our AI-powered cybersecurity platform is being designed to integrate seamlessly with SME business operations, providing intelligent protection against digital threats
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-blue-500 to-transparent z-0"></div>
              )}
              
              <div className="relative bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-blue-500/50 transition-all duration-300 hover:bg-gray-900/70 h-full">
                {/* Step Number */}
                <div className="absolute -top-4 -left-4 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {index + 1}
                </div>

                {/* Icon */}
                <div className="w-16 h-16 bg-blue-500/200/20 rounded-2xl flex items-center justify-center mb-6 mx-auto">
                  <i className={`${step.icon} text-3xl text-blue-400`}></i>
                </div>

                {/* Content */}
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-white mb-2">{step.title}</h3>
                  <h4 className="text-lg text-blue-400 font-medium mb-4">{step.subtitle}</h4>
                  <p className="text-gray-400 leading-relaxed">{step.description}</p>
                </div>

                {/* Features */}
                <div className="space-y-2">
                  {step.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center gap-2">
                      <i className="ri-check-line text-green-400 text-sm"></i>
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Visual Demo */}
        <div className="mt-16 text-center">
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-semibold text-white mb-6">See Driscop in Action</h3>
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop&crop=center"
                alt="Driscop Dashboard Demo"
                className="w-full rounded-xl object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-xl"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-white text-sm">
                  Real-time threat detection and employee training in one unified platform
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
